export default __webpack_public_path__ + "static/media/homeIcon.4da44a16.svg";